import { useInitConsent } from "./overlays/Consent/useInitConsent";
import { useInitCustomBanner } from "./overlays/CustomBanner/useInitCustomBanner";
import { useInitAdjustBanner } from "./overlays/AdjustBanner/useInitAdjustBanner";
import { useInitAirship } from "./overlays/Airship/useInitAirship";
import { useInitGoogleOneTap } from "./overlays/GoogleOneTap/useInitGoogleOneTap";
import { useInitQualtrics } from "./overlays/Qualtrics/useInitQualtrics";

export const useInitOverlayOrchestrator = () => {
  useInitConsent();
  useInitCustomBanner();
  useInitAdjustBanner();
  useInitGoogleOneTap();
  useInitAirship();
  useInitQualtrics();
};
